var map = {
	"./buildings.png": 31670,
	"./buildingscontents.png": 96864,
	"./contents.png": 33291,
	"./criticalillness.png": 28656,
	"./debts.png": 12883,
	"./incomeprotection.png": 97225,
	"./investments.png": 71695,
	"./life.png": 76963,
	"./lifecriticalillness.png": 59066,
	"./medical.png": 91784,
	"./mortgage.png": 24215,
	"./pensions.png": 77500,
	"./pet.png": 10086,
	"./phone.png": 57949,
	"./travel.png": 5041,
	"./vehicle.png": 69137
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61742;